export default {"src":"/_next/static/media/myrooms.6be53d63.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};